import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React, { useState } from 'react'

import styles from './readMore.module.scss'

export interface ReadMoreProps {
  children: string
  className?: string
  maxLength?: number
}
const ReadMore = ({ children, className, maxLength = 146 }: ReadMoreProps) => {
  const text = children
  const size = text.length
  const [isReadMore, setIsReadMore] = useState(true)
  const { t } = useTranslation('common')
  const toggleReadMore = () => {
    setIsReadMore(prevState => !prevState)
  }
  const classes = classnames(styles.container, className)
  return (
    <div data-testid="read-more" data-max-length={maxLength.toString()} className={classes}>
      {isReadMore && size > maxLength ? text.slice(0, maxLength) : text}
      {size > maxLength && (
        <span onClick={toggleReadMore} className={styles.container__readOrHide}>
          {t('ellipsis')} <u> {isReadMore ? t('read_more') : t('show_less')}</u>
        </span>
      )}
    </div>
  )
}
export default ReadMore
